import baseAPIService from './base.api.service'

export default {
  login: async (url, body) =>
    baseAPIService.executeAnonymousMethod(url, 'POST', body),

  get: async (url, anonymous = false, timeout = undefined) => anonymous ?
    baseAPIService.executeAnonymousMethod(url, 'GET', undefined) :
    baseAPIService.executeTokenMethod(url, 'GET', undefined, timeout),

  getExternal: async (url) => baseAPIService.executeExternalMethod(url, 'GET'),

  post: async (url, body = undefined, anonymous = false, timeout = undefined) => anonymous ?
    baseAPIService.executeAnonymousMethod(url, 'POST', body ? body : undefined, undefined) :
    baseAPIService.executeTokenMethod(url, 'POST', body, timeout),

  put: async (url, body = undefined, anonymous = false,  timeout = undefined) => anonymous ?
    baseAPIService.executeAnonymousMethod(url, 'PUT', body ? body : undefined, undefined) :
    baseAPIService.executeTokenMethod(url, 'PUT', body, timeout),

  delete: async (url, anonymous = false, timeout = undefined) => anonymous ?
    baseAPIService.executeAnonymousMethod(url, 'DELETE', undefined) :
    baseAPIService.executeTokenMethod(url, 'DELETE', undefined, timeout),

  upload: async (url, formData, timeout = undefined) =>
    await baseAPIService.executeUploadMethod(url, 'POST', formData, timeout),

  downloadBlob: async (url) =>
    await baseAPIService.executeDownloadBlobMethod(url, 'GET', undefined),
}
